import { graphql } from "relay-runtime"

export const chDeleteEpisodesOfCareMutation = graphql`
  mutation chDeleteEpisodesOfCareMutation($input: Ch_deleteEpisodesOfCareInput!, $connections: [ID!]!) {
    deleteEpisodesOfCare: ch_deleteEpisodesOfCare(input: $input) {
      errors {
        ... on Error {
          message
        }
      }
      ch_EpisodeOfCare {
        id @deleteEdge(connections: $connections)
      }
    }
  }
`
